// eslint-disable-next-line import/named
import { UserCredential } from 'firebase/auth';
import React, { useState } from 'react';

import { useAuth } from '../../../common/hooks/useAuth';
import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { useNavigation } from '../../../common/navigation';
import ValidationAlert from '../ValidationAlert';

import { Register } from './Register';

export type Props = {
  onRegister: (usr: string, pwd: string) => Promise<UserCredential | void>;
};

export const RegisterDialog: React.FC<Props> = ({ onRegister }) => {
  const nav = useNavigation();
  const spdApi = useSpdCore();
  const auth = useAuth();

  const [showError, setShowError] = useState(false);
  const [errorText, setErrorText] = useState('');

  const handleRegister = async (usr: string, pwd: string) => {
    try {
      const dbUser = await spdApi.users.getByEmail(usr);
      if (dbUser) {
        const firebaseUser = await onRegister(usr, pwd);
        if (!firebaseUser?.user.uid) {
          void auth.logout();
          setErrorText('Błędna rejestracja użytkownika');
          setShowError(true);
          return;
        }
        await spdApi.users.updateGet(dbUser.id);
        const freshUser = await spdApi.users.getMe();
        await auth.updateProfile(freshUser || dbUser);
        void nav.startPage();
      }
    } catch (err) {
      void auth.logout();
      setErrorText('Błąd podczas rejestracji: ' + (err as Error).message);
      setShowError(true);
    }
  };

  return (
    <>
      <ValidationAlert
        heading={'REJESTRACJA'}
        variant={'warning'}
        show={showError}
        modal={true}
        onHide={() => {
          setShowError(false);
        }}
        errors={[errorText]}
      />

      <Register onRegister={handleRegister} />
    </>
  );
};
